import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { ReactNode } from "react";

export const cascadeProcessItemStatusColorMap = {
    completed: { color: "green", icon: <CheckCircleOutlined /> },
    failed: { color: "red", icon: <CloseCircleOutlined /> },
    rejected: { color: "red", icon: <CloseCircleOutlined /> },
    declined: { color: "red", icon: <CloseCircleOutlined /> },
    processing: { color: "blue" },
    waiting: { color: "orange" },
    next_waiting: { color: "orange" },
    unused: { color: "default" },
} satisfies Record<App.Enums.CascadeProcessItemStatus, { color: string; icon?: ReactNode }>;
